import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

export type ModalSize = 'small' | 'medium' | 'large';

const MODAL_SIZE_MAP: Record<ModalSize, { width: string; height: string }> = {
  small:  { width: '25%', height: 'auto' },
  medium: { width: '35%', height: '55%' },
  large:  { width: '55%', height: '70%' },
};

/**
 * @deprecated Use simple templates for modal content instead of this component.
 *
 * A standalone modal component is most useful when modal behavior and styling are
 * centralized and reused across multiple features. Since this component primarily
 * serves as a wrapper around projected content (`ng-content`) and does not enforce
 * a specific content structure, a simple template is sufficient and reduces
 * unnecessary abstraction.
 *
 * Only usage: @see ServiceDetailsTableComponent
 */
@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    standalone: false
})
export class ModalComponent implements OnInit {

  @Input() modalTitle = '';
  @Input() modalSize: ModalSize = 'medium';
  @Output() sendCloseSignal = new EventEmitter<boolean>();

  get contentStyles(): { width: string; height: string } {
    return MODAL_SIZE_MAP[this.modalSize];
  }

  constructor() { }

  ngOnInit(): void {}

  onClose() {
    this.sendCloseSignal.emit(false);
  }

}
